import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import { ConfirmProvider } from './contexts/ConfirmContext'
import Landing from './pages/Landing'
import Login from './pages/Login'
import SignUp from './pages/SignUp'
import ForgotPassword from './pages/ForgotPassword'
import RoleDashboard from './pages/RoleDashboard'
import Chat from './pages/Chat'
import Files from './pages/Files'
import Email from './pages/Email'
import Deals from './pages/Deals'
import Assets from './pages/Assets'
import Listings from './pages/Listings'
import Payment from './pages/Payment'
import AdminRoutes from './pages/admin'
import Pricing from './pages/Pricing'
import AccountCreated from './pages/AccountCreated'
import CompleteProfile from './pages/CompleteProfile'
import OAuthCallback from './pages/OAuthCallback'
import Settings from './pages/Settings'
import Contracts from './pages/Contracts'
import Digest from './pages/Digest'
import PrivateRoute from './components/Auth/PrivateRoute'
import AdminRoute from './components/Auth/AdminRoute'
import SessionTimeoutWatcher from './components/Auth/SessionTimeoutWatcher'

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <SessionTimeoutWatcher />
        <Toaster position="top-right" />
        <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/account-created" element={<AccountCreated />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/signup/complete-profile" element={<CompleteProfile />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />

        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<RoleDashboard />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/meetings" element={<Navigate to="/chat" replace />} />
          <Route path="/documents" element={<Files />} />
          <Route path="/digest" element={<Digest />} />
          <Route path="/contracts" element={<Contracts />} />
          <Route path="/email-campaigns" element={<Email />} />
          <Route path="/listings" element={<Listings />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/payment" element={<Payment />} />
          <Route element={<AdminRoute />}>
            <Route path="/admin/*" element={<AdminRoutes />} />
          </Route>
          <Route path="/settings" element={<Settings />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ConfirmProvider>
    </AuthProvider>
  )
}

export default App
